import React from "react";
import heartIcon from "./Images/wishlist.svg";
import heartIconFull from "./Images/wishlist_full.svg";

interface ButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isSelected: boolean;
}

const wishlistButtonStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.2s ease-in-out",
};

const WishlistButton: React.FunctionComponent<ButtonProps> = ({isSelected = false, onClick}) => {
  return (
    <button
      style={wishlistButtonStyle}
      title="Add to wishlist"
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.children[0] as SVGElement).style.fill = "#c39d63"}
      onMouseLeave={(e) => (e.currentTarget.children[0] as SVGElement).style.fill = "none"}
    >
      <img src={isSelected ? heartIconFull : heartIcon} alt="Wishlist" width={30} height={30} />
    </button>
  );
};

export default WishlistButton;
